import { forwardRef } from 'react';
import type { PropsWithoutRef } from 'react';

import type { ForwardRefForwardPropsComponent } from '../../types';

import { StyledProgressRing } from './Progress.styles';
import type { ProgressProps } from './Progress.types';

const Ring: ForwardRefForwardPropsComponent<ProgressProps> = forwardRef(function Ring(
  { value, minValue = 0, maxValue = 100, placement, ...restProps }: PropsWithoutRef<ProgressProps>,
  ref: ProgressProps['ref']
) {
  let strokeDashoffset;
  const circumference = 18 * Math.PI;

  if (typeof value !== 'number') strokeDashoffset = (1 - 33 / 100) * circumference;
  else if (value > maxValue || minValue > maxValue) strokeDashoffset = 0;
  else if (value < minValue) strokeDashoffset = circumference;
  else strokeDashoffset = (1 - (value - minValue) / (maxValue - minValue)) * circumference;

  return (
    <StyledProgressRing
      ref={ref}
      role='progressbar'
      aria-valuemin={minValue}
      aria-valuemax={maxValue}
      aria-valuenow={value}
      placement={placement}
      determinate={typeof value === 'number'}
      {...restProps}
    >
      <svg viewBox='0 0 20 20'>
        <circle />
        <circle strokeDasharray={circumference} style={{ strokeDashoffset }} />
      </svg>
    </StyledProgressRing>
  );
});

export default Ring;
